<template>
 <div class="bg-white p-4 rounded-lg shadow">
  <apexchart type="bar" :options="chartOptions" :series="series" />
 </div>
</template>

<script>
export default {
 name: "BarChart",
 props: {
  series: {
   type: Array,
   required: true,
  },
  categories: {
   type: Array,
   required: true,
  },
  title: {
   type: String,
   default: "Minutes Breakdown",
  },
  yAxisTitle: {
   type: String,
   default: "Minutes",
  },
 },
 computed: {
  chartOptions() {
   return {
    chart: {
     type: "bar",
     height: "100%",
     toolbar: { show: false },
    },
    title: {
     text: this.title,
     align: "left",
     style: {
      fontSize: "16px",
      color: "#333",
     },
    },
    subtitle: {
     text: this.$t("minutesBreakdownByPeriod"),
    },
    plotOptions: {
     bar: {
      horizontal: false,
      columnWidth: "55%",
      endingShape: "rounded",
     },
    },
    colors: ["#e5e7eb", "#3b82f6", "#33c1ff", "#10b981"],
    dataLabels: { enabled: false },
    stroke: {
     show: true,
     width: 2,
     colors: ["transparent"],
    },
    xaxis: {
     categories: this.categories,
     labels: {
      style: { colors: "#6b7280" },
     },
    },
    yaxis: {
     title: { text: "Minutes" },
     labels: {
      style: { colors: "#6b7280" },
     },
    },
    fill: {
     opacity: 0.8,
    },
    legend: {
     position: "top",
     horizontalAlign: "right",
    },
    tooltip: {
     y: {
      formatter: function (val) {
       return val + " minutes";
      },
     },
    },
   };
  },
 },
};
</script>
